/* src/app/private/components/domain-authentication/delete-domain/delete-domain.component.scss */
/*# sourceMappingURL=delete-domain.component.css.map */
